
    import Review from "../main/review";
    export default {
      name: "ReviewBlock",
      components: {Review},
      props: {
        info_lading: {
          type: Object,
          default: {
            lading_page: [],
            reviews: [],
            price: []
          }
        },
        city_a: {
          type: String,
          default: '',
        },
        city_b: {
          type: String,
          default: '',
        }
      },
      data() {
        return {}
      }
    }
